import type { MvpCharacterId } from '../session/game-session';
import { CHARACTER_SKILL_LABELS } from '../ui/ui-labels';

export type SuperCharacterType = MvpCharacterId;

export interface SuperTheme {
  readonly primaryColor: number;
  readonly secondaryColor: number;
  readonly bannerBgColor: number;
  readonly bannerBorderColor: number;
  readonly textColor: string;
  readonly tagColor: string;
  readonly tagText: string;
  readonly superName: string;
}

export const SUPER_THEMES: Readonly<Record<SuperCharacterType, SuperTheme>> = Object.freeze({
  sales: Object.freeze({
    primaryColor: 0xfacc15,
    secondaryColor: 0xfde047,
    bannerBgColor: 0x18181b,
    bannerBorderColor: 0xfacc15,
    textColor: '#ffffff',
    tagColor: '#facc15',
    tagText: '★ APPROVED — COMMITMENT ★',
    superName: CHARACTER_SKILL_LABELS.sales.super,
  }),
  developer: Object.freeze({
    primaryColor: 0x38bdf8,
    secondaryColor: 0xf472b6,
    bannerBgColor: 0x0f172a,
    bannerBorderColor: 0x38bdf8,
    textColor: '#e0f2fe',
    tagColor: '#38bdf8',
    tagText: '[ SYSTEM EVENT : ROLLBACK ]',
    superName: CHARACTER_SKILL_LABELS.developer.super,
  }),
});
